import React, { useEffect, useState } from "react";
import styles from "../prospectdetails.module.css";
import { Calendar, Check, DollarSign, Edit, FileText, Image, Save, Trash2, X } from "react-feather";
import { useAuth0 } from "@auth0/auth0-react";
import Loader from "../../../components/Loader";
import axios from "axios";
import { toast } from "react-smart-toaster";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DatePicker } from "@material-ui/pickers";
import { AddLogCallAPI } from "../../../components/AddLogs";
import UploaderComponent from "./UploaderComponent";
import { Accordion, AccordionDetails, AccordionSummary, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, MenuItem, Select, TextField } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import NumberFormat from "react-number-format";
import { usePlacesWidget } from "react-google-autocomplete";
import dayjs from "dayjs";

const phoneRegExp = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

const PhoneField = React.forwardRef((props, ref) => {
  return <NumberFormat
    prefix=""
    displayType="input"
    type="tel"
    format={"(###) ###-####"}
    {...props} />;
});

const FiveDigitFieldformat = React.forwardRef((props, ref) => {
  return <NumberFormat
    prefix=""
    displayType="input"
    type="text"
    thousandSeparator={false}
    decimalScale={0} {...props} />;
});

const TenDigitField = React.forwardRef((props, ref) => {
  return <NumberFormat
    prefix=""
    displayType="input"
    type="text"
    thousandSeparator={false}
    decimalScale={0}
    {...props}
  />;
});

const MoneyFieldCurrentRent = React.forwardRef((props, ref) => {
  return <NumberFormat
    prefix=""
    displayType="input"
    type="text"
    thousandSeparator={true}
    allowNegative={false}
    decimalScale={2}
    fixedDecimalScale
    {...props}
  />;
});


const MoneyField = React.forwardRef((props, ref) => {
  return <NumberFormat
    prefix=""
    displayType="input"
    type="text"
    thousandSeparator={true}
    allowNegative={false}
    decimalScale={0}
    {...props}
  />;
});

const ProspectTab = (props) => {
  const { user, isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState("");
  const [selectedApartment, setselectedApartment] = useState({ value: 0, label: "" });
  const [StateList, setStateList] = useState({ data: [], loading: false });
  const [isRename, setIsRename] = useState({ itemId: 0, error: false, value: "" });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fileDeleteId, setFileDeleteId] = useState(0);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    async function fetchState() {
      await axios.get(process.env.REACT_APP_PROPERTY_API_URL + "v1/states").then((response) => {
        setStateList({ data: response.data.data, loading: false });
      }).catch((error) => {
        setStateList({ data: [], loading: true });
      });
    }

    fetchState();
  }, [props?.applicantData]);

  useEffect(() => {
    setselectedApartment({ label: props?.apartment?.apt_no + " - " + props?.apartment?.apt_type + " / " + props?.apartment?.bathroom + " Bath", value: props?.apartment?.id, type: props?.apartment?.apt_type });
  }, [props?.apartment]);

  const fileRenameFormOpen = (itemId, itemTitle, event) => {
    event.stopPropagation();
    itemTitle = itemTitle.replace(/\.[^/.]+$/, "");
    setIsRename({ itemId: itemId, error: false, value: itemTitle });
  };

  const fileRenameSave = async () => {
    if (isRename?.value === "") {
      setIsRename({ ...isRename, error: true });
    } else {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      let logData = {};
      setLoading(true);
      const postData = { file_name: isRename?.value };
      let applicantId = props?.applicantData?.id;
      return axios.put(process.env.REACT_APP_APPLICANT_API_URL + "v1/applicants/" + applicantId + "/files/" + isRename?.itemId, postData, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        setLoading(false);

        props?.setSnackbarMsg(response.data.message);
        props?.setSnackbarOpen(true);

        let files = response.data.data;

        let allFiles = props?.applicantData?.files.map((el) =>
          el.id === isRename?.itemId ? { ...el, file_name: files?.file_name } : el
        );

        props.updateFileList(allFiles, props?.applicant_index);
        setIsRename({ itemId: 0, itemType: "", error: false, value: "" });

        logData = {
          title: "Applicant file renamed",
          description: [
            "Name: " + props?.applicantData?.full_name,
            "Email: " + props?.applicantData?.email,
            "Phone: " + props?.applicantData?.phone,
            "File: " + files?.file_name,
          ],
        };
        AddLogCallAPI(logData, token);
      }).catch((error) => {
        if (typeof error.response !== "undefined")
          toast.error(error.response.data.message);
        setLoading(false);
      });
    }
  };

  const deleteFile = async () => {
    let fileDeleteIdTemp = fileDeleteId;
    setIsModalOpen(false);
    setFileDeleteId(0);

    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    let logData = {};
    setLoading(true);

    let applicantId = props?.applicantData?.id;

    return axios.delete(process.env.REACT_APP_APPLICANT_API_URL + "v1/applicants/" + applicantId + "/files/" + fileDeleteIdTemp, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {

      props?.setSnackbarMsg(response.data.message);
      props?.setSnackbarOpen(true);

      setLoading(false);

      let delFile = props?.applicantData?.files.filter((item) => item.id === fileDeleteIdTemp);
      let allFiles = props?.applicantData?.files.filter((item) => item.id !== fileDeleteIdTemp);

      props.updateFileList(allFiles, props?.applicant_index);

      logData = {
        title: "Applicant file deleted",
        description: [
          "Name: " + props?.applicantData?.full_name,
          "Email: " + props?.applicantData?.email,
          "Phone: " + props?.applicantData?.phone,
          "File: " + delFile[0].file_name,
        ],
      };
      AddLogCallAPI(logData, token);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  };

  const onFileUploadSuccess = (files) => {
    let logData = {};

    let allFiles = props?.applicantData?.files;
    allFiles = [files].concat(allFiles);

    props.updateFileList(allFiles, props?.applicant_index);

    setLoading(false);

    logData = {
      title: "Applicant file uploaded",
      description: [
        "Name: " + props?.applicantData?.full_name,
        "Email: " + props?.applicantData?.email,
        "Phone: " + props?.applicantData?.phone,
        "File Name: " + files?.file_name,
      ],
    };

    props?.setSnackbarMsg('Files uploaded successfully.');
    props?.setSnackbarOpen(true);

    AddLogCallAPI(logData, this.token);
  };

  const openFile = (item) => {
    window.open(item?.file_url, '_blank')
  }

  const [charsLeft, setCharsLeft] = useState({ reason_for_moving: props?.applicantData?.reason_for_moving ? 200 - props?.applicantData?.reason_for_moving?.length : 200, who_live_with_you: props?.applicantData?.who_live_with_you ? 200 - props?.applicantData?.who_live_with_you?.length : 200, additional_information: props?.applicantData?.additional_information ? 200 - props?.applicantData?.additional_information?.length : 200 });
  const [incomeType, setIncomeType] = useState(props?.applicantData?.income_type ? props?.applicantData?.income_type : 'Salary');
  const [incomeType2, setIncomeType2] = useState(props?.applicantData?.income_type2 ? props?.applicantData?.income_type2 : 'Salary');

  const { register: register1, handleSubmit: handleSubmit1, control: control1, watch: watch1, formState: { errors: errors1 }, clearErrors: clearErrors1 } = useForm({
    mode: "onChange"
  });

  const { register: register2, handleSubmit: handleSubmit2, control: control2, watch: watch2, formState: { errors: errors2 }, clearErrors: clearErrors2, setValue: setValue2 } = useForm({
    mode: "onChange"
  });

  const { register: register3, handleSubmit: handleSubmit3, control: control3, watch: watch3, formState: { errors: errors3 } } = useForm({
    mode: "onChange"
  });

  const { register: register4, handleSubmit: handleSubmit4, control: control4, watch: watch4, formState: { errors: errors4 }, clearErrors: clearErrors4, setValue: setValue4 } = useForm({
    mode: "onChange"
  });

  const { register: register5, handleSubmit: handleSubmit5, control: control5, watch: watch5, formState: { errors: errors5 }, clearErrors: clearErrors5, setValue: setValue5 } = useForm({
    mode: "onChange"
  });

  const { register: register6, handleSubmit: handleSubmit6, control: control6, watch: watch6, formState: { errors: errors6 } } = useForm({
    mode: "onChange"
  });

  const checkEmailIsUnique = (phone) => {
    return axios.get(process.env.REACT_APP_APPLICANT_API_URL + 'v1/check-phone-new-2/' + phone + '/' + props?.applicantData?.id);
  }

  const phoneIsUnique = async (phone) => {
    const isEmailUnique = await checkEmailIsUnique(phone);

    return isEmailUnique?.data?.status;
  }

  const { ref: autocompleteRef } = usePlacesWidget({
    apiKey: process.env.REACT_APP_MAP_API_KEY,
    options: {
      types: ["address"],
      componentRestrictions: { country: "us" },
      fields: ["address_components", "geometry"],
    },
    onPlaceSelected: (place) => {
      let address = "";
      let city = "";
      let state = "";
      let postcode = "";

      for (let component of place.address_components) {
        let componentType = component.types[0];
        switch (componentType) {
          case "street_number": {
            address = component.long_name;
            break;
          }
          case "route": {
            address += ' ' + component.short_name;
            break;
          }
          case "postal_code": {
            postcode = component.long_name;
            break;
          }
          case "locality": {
            if (city === '')
              city = component.long_name;
            break;
          }
          case "sublocality_level_1": {
            city = component.long_name;
            break;
          }
          case "administrative_area_level_1": {
            state = component.short_name;
            break;
          }
          default:
            break;
        }
      }

      setValue2('address', address);
      setValue2('city', city);
      setValue2('state', state);
      setValue2('zip', postcode);
      clearErrors2();
    }
  })

  const { ref: autocompleteRef2 } = usePlacesWidget({
    apiKey: process.env.REACT_APP_MAP_API_KEY,
    options: {
      types: ["address"],
      componentRestrictions: { country: "us" },
      fields: ["address_components", "geometry"],
    },
    onPlaceSelected: (place) => {
      let address = "";
      let city = "";
      let state = "";
      let postcode = "";
      for (let component of place.address_components) {
        let componentType = component.types[0];
        switch (componentType) {
          case "street_number": {
            address = component.long_name;
            break;
          }
          case "route": {
            address += ' ' + component.short_name;
            break;
          }
          case "postal_code": {
            postcode = component.long_name;
            break;
          }
          case "locality": {
            if (city === '')
              city = component.long_name;
            break;
          }
          case "sublocality_level_1": {
            city = component.long_name;
            break;
          }
          case "administrative_area_level_1": {
            state = component.short_name;
            break;
          }
          default:
            break;
        }
      }
      let full_address = address + ', ' + city + ', ' + state + ' ' + postcode;
      setValue4('employer_address', full_address);
      clearErrors4();
    }
  })

  const { ref: autocompleteRef3 } = usePlacesWidget({
    apiKey: process.env.REACT_APP_MAP_API_KEY,
    options: {
      types: ["address"],
      componentRestrictions: { country: "us" },
      fields: ["address_components", "geometry"],
    },
    onPlaceSelected: (place) => {
      let address = "";
      let city = "";
      let state = "";
      let postcode = "";
      for (let component of place.address_components) {
        let componentType = component.types[0];
        switch (componentType) {
          case "street_number": {
            address = component.long_name;
            break;
          }
          case "route": {
            address += ' ' + component.short_name;
            break;
          }
          case "postal_code": {
            postcode = component.long_name;
            break;
          }
          case "locality": {
            if (city === '')
              city = component.long_name;
            break;
          }
          case "sublocality_level_1": {
            city = component.long_name;
            break;
          }
          case "administrative_area_level_1": {
            state = component.short_name;
            break;
          }
          default:
            break;
        }
      }
      let full_address = address + ', ' + city + ', ' + state + ' ' + postcode;
      setValue5('employer_address2', full_address);
      clearErrors5();
    }
  })

  const onSubmit1 = (data) => {
    if (data?.birth_date) {
      data = { ...data, birth_date: dayjs(data?.birth_date).format("YYYY-MM-DD") };
    }
    data = { ...data, is_personal_info_submitted: 1 };
    onProspectInfoSubmit(data);
  }

  const onSubmit2 = (data) => {
    data = { ...data, is_address_submitted: 1 };
    onProspectInfoSubmit2(data);
  }

  const onSubmit3 = (data) => {
    data = { ...data, is_rental_info_submitted: 1 };
    onProspectInfoSubmit2(data);
  }

  const onSubmit4 = (data) => {
    data = { ...data, hire_date: dayjs(data?.hire_date).format("YYYY-MM-DD"), is_employement_submitted: 1 };
    onProspectInfoSubmit2(data);
  }

  const onSubmit5 = (data) => {
    data = { ...data, hire_date2: dayjs(data?.hire_date2).format("YYYY-MM-DD"), is_employement2_submitted: 1 };
    onProspectInfoSubmit2(data);
  }

  const onSubmit6 = (data) => {
    data = { ...data, is_other_info_submitted: 1 };
    onProspectInfoSubmit2(data);
  }

  const onProspectInfoSubmit = async (data) => {
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.put(process.env.REACT_APP_APPLICANT_API_URL + "v1/prospects/" + props?.applicantData?.id, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      setLoading(false);
      props?.setSnackbarOpen(true);
      props?.setSnackbarMsg(response.data.message);

      props?.updateApplicantData(response.data.data);
    }).catch((error) => {
      setLoading(false);
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
    });
  }

  const onProspectInfoSubmit2 = async (data) => {
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.put(process.env.REACT_APP_APPLICANT_API_URL + "v1/prospect-update/" + props?.applicantData?.id, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      setLoading(false);
      props?.setSnackbarOpen(true);
      props?.setSnackbarMsg(response.data.message);

      props?.updateApplicantData(response.data.data);
    }).catch((error) => {
      setLoading(false);
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
    });
  }

  return (<>
    {loading && <Loader />}

    <div className="FormAccording ProspectTask Theme">
      <Accordion expanded={expanded === "panel1"} onChange={handleChange("panel1")}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
          <div className={`${styles.FormAccoHead}`}>
            <p className={`${styles.FormAccoHeadTitle}`}>Basic information</p>
            <div className={(props?.applicantData?.is_personal_info_submitted === 1) ? `${styles.AccoCheck} ${styles.Active}` : `${styles.AccoCheck}`}>
              <Check />
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails className={`${styles.CussAccoRow}`}>
          <div className={`${styles.AccoFormSec}`}>
            <div className={`${styles.FormGroupFull} CusSelect Select`}>
              <div className={`${styles.Width100}`}>
                <label className={`${styles.FormLabel}`}>Apt #</label>
                <FormControl fullWidth disabled>
                  <Select value={selectedApartment?.value}>
                    <MenuItem value={selectedApartment?.value}>{selectedApartment?.label}</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>

            <div className={`${styles.ToggleBUHalf}`}>
              <label className={`${styles.FormLabel}`}>Specify the number of applicants</label>
              <button className={`${styles.AppliFormToggleBU} ${styles.Active}`}>
                {props?.no_of_applicants}
              </button>
            </div>
            {props?.applicantData?.move_in_date !== "" && props?.applicantData?.move_in_date !== "null" && (<div className={`${styles.FormGroupHalf}`}>
              <label className={`${styles.FormLabel}`}>Desired move-in date</label>
              <div className={`${styles.Width100}`}>
                <div className={`AppliAccoFormDate Select ${styles.AppliAccoFormDateTenantDE}`}>
                  <DatePicker
                    label="Basic example"
                    format="MM/dd/yyyy"
                    value={props?.applicantData?.formatted_move_in_date}
                    animateYearScrolling
                    disabled
                  />
                  <p className={`${styles.CalendarIcon}`}><Calendar /></p>
                </div>
              </div>
            </div>)}
          </div>
        </AccordionDetails>
      </Accordion>

      <Accordion expanded={expanded === "panel2"} onChange={handleChange("panel2")}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
          <div className={`${styles.FormAccoHead}`}>
            <p className={`${styles.FormAccoHeadTitle}`}>Personal information</p>
            <div className={(props?.applicantData?.is_personal_info_submitted === 1) ? `${styles.AccoCheck} ${styles.Active}` : `${styles.AccoCheck}`}>
              <Check />
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails className={`${styles.CussAccoRow}`}>
          <form onSubmit={handleSubmit1(onSubmit1)}>
            <div className={`${styles.AccoFormSec}`}>
              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>First name</label>
                <div className={`${styles.Width100}`}>
                  <Controller
                    render={(fields) => (
                      <input
                        {...fields}
                        type="text"
                        className={`${styles.formControl}`}
                      />
                    )}
                    control={control1}
                    name="first_name"
                    ref={register1}
                    defaultValue={props?.applicantData?.first_name}
                    rules={{
                      required: "This field is required.",
                      maxLength: {
                        value: 50,
                        message:
                          "First name cannot be more than 50 characters.",
                      },
                    }}
                  />
                  {errors1.first_name && (<p className={`${styles.ErrorM}`}>{errors1.first_name.message}</p>)}
                </div>
              </div>
              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>Middle initial <span>Optional</span></label>
                <div className={`${styles.Width100}`}>
                  <Controller
                    render={(fields) => (
                      <input
                        {...fields}
                        type="text"
                        className={`${styles.formControl}`}
                        onChange={(e) => {
                          fields.onChange(e);
                        }}
                      />
                    )}
                    control={control1}
                    name="middle_name"
                    ref={register1}
                    defaultValue={props?.applicantData?.middle_name}
                    rules={{
                      maxLength: {
                        value: 50,
                        message: "Middle initial cannot be more than 50 characters.",
                      },
                    }}
                  />
                  {errors1.middle_name && (<p className={`${styles.ErrorM}`}>{errors1.middle_name.message}</p>)}
                </div>
              </div>
              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>Last name</label>
                <div className={`${styles.Width100}`}>
                  <Controller
                    render={(fields) => (
                      <input
                        {...fields}
                        type="text"
                        className={`${styles.formControl}`}
                        onChange={(e) => {
                          fields.onChange(e);
                        }}
                      />
                    )}
                    control={control1}
                    name="last_name"
                    ref={register1}
                    defaultValue={props?.applicantData?.last_name}
                    rules={{
                      required: "This field is required.",
                      maxLength: {
                        value: 50,
                        message: "Last name cannot be more than 50 characters.",
                      },
                    }}
                  />
                  {errors1.last_name && (<p className={`${styles.ErrorM}`}>{errors1.last_name.message}</p>)}
                </div>
              </div>
              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>Birth date</label>
                <div className={`${styles.Width100}`}>
                  <div className={`AppliAccoFormDate Select ${styles.AppliAccoFormDateTenantDE}`}>
                    <Controller
                      control={control1}
                      name="birth_date"
                      animateYearScrolling
                      render={(fields) => (
                        <DatePicker
                          placeholder="MM/DD/YYYY"
                          format="MM/dd/yyyy"
                          value={fields.value ? fields.value : null}
                          onChange={(e) => {
                            fields.onChange(e);
                          }}
                          error={false}
                          maxDate={dayjs().subtract(18, "years")}
                          helperText={null}
                        />
                      )}
                      rules={{ required: "This field is required." }}
                      defaultValue={props?.applicantData?.birth_date ? props?.applicantData?.birth_date : null}
                    />
                    <p className={`${styles.CalendarIcon}`}><Calendar /></p>
                  </div>
                  {errors1.birth_date && (<p className={`${styles.ErrorM}`}>{errors1.birth_date.message}</p>)}
                </div>
              </div>
              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>Driver's license or ID #</label>
                <div className={`${styles.Width100}`}>
                  <Controller
                    render={(fields) => (
                      <input
                        {...fields}
                        type="text"
                        className={`${styles.formControl}`}
                        onChange={(e) => {
                          fields.onChange(e);
                        }}
                      />
                    )}
                    control={control1}
                    name="driver_license"
                    ref={register1}
                    defaultValue={props?.applicantData?.driver_license}
                    rules={{
                      required: "This field is required.",
                      maxLength: {
                        value: 15,
                        message: "This field cannot be more than 15 characters.",
                      },
                      pattern: {
                        value: /^[0-9a-zA-Z ]+$/,
                        message: "Please enter a valid driver's license or id.",
                      },
                    }}
                  />
                  {errors1.driver_license && (<p className={`${styles.ErrorM}`}>{errors1.driver_license.message}</p>)}
                </div>
              </div>
              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>Social security number</label>
                <div className={`${styles.Width100}`}>
                  <input type="text" className={`${styles.formControl}`} value={'**********'} disabled />
                </div>
              </div>
              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>Email address</label>
                <div className={`${styles.Width100}`}>
                  <Controller
                    render={(fields) => (
                      <input
                        {...fields}
                        type="text"
                        className={`${styles.formControl}`}
                        onChange={(e) => {
                          fields.onChange(e);
                        }}
                      />
                    )}
                    control={control1}
                    name="email"
                    ref={register1}
                    defaultValue={props?.applicantData?.email}
                    rules={{
                      required: "This field is required.",
                      email: "Invalid email",
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Invalid email."
                      }
                    }}
                  />
                  {errors1.email && (<p className={`${styles.ErrorM}`}>{errors1.email.message}</p>)}
                </div>
              </div>
              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>Phone </label>
                <div className={`${styles.Width100}`}>
                  <FormControl fullWidth>
                    <Controller
                      render={(field) => (<PhoneField
                        {...field}
                        type="text"
                        className={`${styles.formControl}`}
                        onChange={(e) => {
                          field.onChange(e);
                        }} />)}
                      control={control1}
                      name="phone"
                      ref={register1}
                      defaultValue={props?.applicantData?.phone}
                      onKeyUp={(e) => clearErrors1()}
                      rules={{
                        required: 'This field is required.',
                        pattern: {
                          value: phoneRegExp,
                          message: "Please enter a valid phone number.",
                          excludeEmptyString: true
                        },
                        validate: {
                          phoneIsUnique: phoneIsUnique
                        }
                      }}
                    />
                  </FormControl>
                  {errors1.phone && (<p className={`${styles.ErrorM}`}>{errors1.phone.message}</p>)}
                  {(errors1.phone && errors1.phone.type === "phoneIsUnique") && <p className={`${styles.ErrorM}`}>Phone number is already registered.</p>}
                </div>
              </div>
            </div>

            {(props?.applicantData?.first_name !== watch1('first_name') || props?.applicantData?.last_name !== watch1('last_name') || dayjs(props?.applicantData?.birth_date).format("MM/DD/YYYY") !== dayjs(watch1('birth_date')).format("MM/DD/YYYY") || props?.applicantData?.driver_license !== watch1('driver_license') || props?.applicantData?.email !== watch1('email') || props?.applicantData?.phone !== watch1('phone')) && <button type="submit" className={`${styles.ButtonVoiletSolidSM}`}>Update</button>}

          </form>
        </AccordionDetails>
      </Accordion>

      <Accordion expanded={expanded === "panel3"} onChange={handleChange("panel3")}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel3bh-content" id="panel3bh-header">
          <div className={`${styles.FormAccoHead}`}>
            <p className={`${styles.FormAccoHeadTitle}`}>Address</p>
            <div className={(props?.applicantData?.is_address_submitted === 1) ? `${styles.AccoCheck} ${styles.Active}` : `${styles.AccoCheck}`}>
              <Check />
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <form onSubmit={handleSubmit2(onSubmit2)}>
            <div className={`${styles.AccoFormSec}`}>
              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>Current street address</label>
                <div className={`${styles.Width100}`}>
                  <Controller
                    render={(field) => (<TextField
                      {...field}
                      inputRef={autocompleteRef}
                      autoComplete='off'
                      placeholder=""
                      className={`${styles.formControl}`}
                    />
                    )}
                    control={control2}
                    name="address"
                    ref={register2}
                    defaultValue={props?.applicantData?.address}
                    rules={{
                      required: 'This field is required.',
                      maxLength: {
                        value: 50,
                        message: "Address cannot be more than 50 characters."
                      }
                    }}
                  />
                  {errors2.address && (<p className={`${styles.ErrorM}`}>{errors2.address.message}</p>)}
                </div>
              </div>
              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>Street address <span>Optional</span></label>
                <div className={`${styles.Width100}`}>
                  <Controller
                    render={(fields) => (
                      <input
                        {...fields}
                        type="text"
                        className={`${styles.formControl}`}
                        onChange={(e) => {
                          fields.onChange(e);
                        }}
                      />
                    )}
                    control={control2}
                    name="address2"
                    ref={register2}
                    defaultValue={props?.applicantData?.address2}
                    rules={{
                      maxLength: {
                        value: 50,
                        message: "Street address cannot be more than 50 characters."
                      }
                    }}
                  />
                  {errors2.address2 && (<p className={`${styles.ErrorM}`}>{errors2.address2.message}</p>)}
                </div>
              </div>
              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>City </label>
                <div className={`${styles.Width100}`}>
                  <Controller
                    render={(fields) => (
                      <input
                        {...fields}
                        type="text"
                        className={`${styles.formControl}`}
                        onChange={(e) => {
                          fields.onChange(e);
                        }}
                      />
                    )}
                    control={control2}
                    name="city"
                    ref={register2}
                    defaultValue={props?.applicantData?.city}
                    rules={{
                      required: 'This field is required.',
                      maxLength: {
                        value: 50,
                        message: "City cannot be more than 50 characters."
                      }
                    }}
                  />
                  {errors2.city && (<p className={`${styles.ErrorM}`}>{errors2.city.message}</p>)}
                </div>
              </div>
              <div className={`${styles.FormGroupHalf} CusSelect Select`}>
                <label className={`${styles.FormLabel}`}>State</label>
                <div className={`${styles.Width100}`}>
                  <FormControl fullWidth>
                    <Controller
                      name="state"
                      control={control2}
                      rules={{
                        required: 'This field is required.',
                      }}
                      defaultValue={props?.applicantData?.state}
                      render={(field) => (
                        <Select
                          {...field}
                          onChange={(e) => {
                            field.onChange(e);
                          }}
                        >
                          {StateList?.data?.map(item => {
                            return (< MenuItem key={item?.value} value={item?.value}>{item?.label}</MenuItem>);
                          })}
                        </Select>
                      )}
                    />
                    {errors2.state && <p className={`${styles.ErrorM}`}>{errors2.state.message}</p>}
                  </FormControl>
                </div>
              </div>
              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>Zip code </label>
                <div className={`${styles.Width100}`}>
                  <Controller
                    render={(field) => (<FiveDigitFieldformat
                      {...field}
                      label="Zip code"
                      type="text"
                      className={`${styles.formControl}`}
                      onChange={(e) => {
                        field.onChange(e);
                      }} />)}
                    control={control2}
                    name="zip"
                    ref={register2}
                    defaultValue={props?.applicantData?.zip}
                    rules={{
                      required: 'This field is required.',
                      pattern: {
                        value: /\b\d{5}\b/,
                        message: "Please enter a valid zip code."
                      },
                    }}
                  />
                  {errors2.zip && (<p className={`${styles.ErrorM}`}>{errors2.zip.message}</p>)}
                </div>
              </div>
            </div>

            {(props?.applicantData?.address !== watch2('address') || props?.applicantData?.address2 !== watch2('address2') || props?.applicantData?.city !== watch2('city') || props?.applicantData?.state !== watch2('state') || props?.applicantData?.zip !== watch2('zip')) && <button type="submit" className={`${styles.ButtonVoiletSolidSM}`}>Update</button>}
          </form>
        </AccordionDetails>
      </Accordion>

      <Accordion expanded={expanded === "panel4"} onChange={handleChange("panel4")}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel4bh-content" id="panel4bh-header">
          <div className={`${styles.FormAccoHead}`}>
            <p className={`${styles.FormAccoHeadTitle}`}>Rental Information</p>
            <div className={(props?.applicantData?.is_rental_info_submitted === 1) ? `${styles.AccoCheck} ${styles.Active}` : `${styles.AccoCheck}`}>
              <Check />
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <form onSubmit={handleSubmit3(onSubmit3)}>
            <div className={`${styles.AccoFormSec}`}>
              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>Name of present landlord</label>
                <div className={`${styles.Width100}`}>
                  <Controller
                    render={(fields) => (
                      <input
                        {...fields}
                        type="text"
                        className={`${styles.formControl}`}
                        onChange={(e) => {
                          fields.onChange(e);
                        }}
                      />
                    )}
                    control={control3}
                    name="landlord_name"
                    ref={register3}
                    defaultValue={props?.applicantData?.landlord_name}
                    rules={{
                      required: "This field is required.",
                      maxLength: {
                        value: 50,
                        message: "Landlord name cannot be more than 50 characters."
                      }
                    }}
                  />
                  {errors3.landlord_name && (<p className={`${styles.ErrorM}`}>{errors3.landlord_name.message}</p>)}
                </div>
              </div>
              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>Phone number of present landlord</label>
                <div className={`${styles.Width100}`}>
                  <Controller
                    render={(field) => (
                      <PhoneField
                        {...field}
                        type="text"
                        className={`${styles.formControl}`}
                      />
                    )}
                    control={control3}
                    name="landlord_phone_no"
                    ref={register3}
                    defaultValue={props?.applicantData?.landlord_phone_no}
                    rules={{
                      required: 'This field is required.',
                      pattern: {
                        value: phoneRegExp,
                        message: "Please enter a valid phone number.",
                        excludeEmptyString: true
                      }
                    }}
                  />
                  {errors3.landlord_phone_no && (<p className={`${styles.ErrorM}`}>{errors3.landlord_phone_no.message}</p>)}
                </div>
              </div>
              <div className={`${styles.FormGroupFull} CusTextArea`}>
                <label className={`${styles.FormLabel}`}>Reason for moving</label>
                <div className={`${styles.Width100}`}>
                  <Controller
                    render={(field) => (
                      <TextField
                        {...field}
                        multiline
                        className={`${styles.formControlTextarea}`}
                        rows={6}
                        onChange={(e) => {
                          field.onChange(e);
                          setCharsLeft((prev) => {
                            return { ...prev, reason_for_moving: 200 - e.target.value.length };
                          });
                        }}
                        inputProps={{ maxLength: 200 }}
                      />
                    )}
                    control={control3}
                    name="reason_for_moving"
                    ref={register3}
                    defaultValue={props?.applicantData?.reason_for_moving}
                    rules={{
                      required: "This field is required.",
                      maxLength: {
                        value: 200,
                        message: "Reason for moving can not be more than 200 characters."
                      }
                    }}
                  />
                  <p className={`${styles.FormFieldMessage}`}>{charsLeft?.reason_for_moving > 1 ? charsLeft?.reason_for_moving + " characters remaining" : charsLeft?.reason_for_moving + " character remaining"}</p>
                  {errors3.reason_for_moving && (<p className={`${styles.ErrorM}`}>{errors3.reason_for_moving.message}</p>)}
                </div>
              </div>
              <div className={`${styles.FormGroupFull} CusTextArea`}>
                <label className={`${styles.FormLabel}`}>Who else will be living with you? Please provide their first name, last name, birth date and relationship to you</label>
                <div className={`${styles.Width100}`}>
                  <Controller
                    render={(field) => (
                      <TextField
                        {...field}
                        multiline
                        rows={6}
                        className={`${styles.formControlTextarea}`}
                        onChange={(e) => {
                          field.onChange(e);
                          setCharsLeft((prev) => {
                            return { ...prev, who_live_with_you: 200 - e.target.value.length };
                          });
                        }}
                        inputProps={{ maxLength: 200 }}
                      />
                    )}
                    control={control3}
                    name="who_live_with_you"
                    ref={register3}
                    defaultValue={props?.applicantData?.who_live_with_you}
                    rules={{
                      required: "This field is required.",
                      maxLength: {
                        value: 200,
                        message: "Who else will be living with you ? can not be more than 200 characters."
                      }
                    }}
                  />
                  <p className={`${styles.FormFieldMessage}`}>{charsLeft?.who_live_with_you > 1 ? charsLeft?.who_live_with_you + " characters remaining" : charsLeft?.who_live_with_you + " character remaining"}</p>
                  {errors3.who_live_with_you && (<p className={`${styles.ErrorM}`}>{errors3.who_live_with_you.message}</p>)}
                </div>
              </div>
              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>How many months have you lived at present address?</label>
                <div className={`${styles.Width100}`}>
                  <Controller
                    render={(field) => (
                      <TenDigitField
                        {...field}
                        type="text"
                        className={`${styles.formControl}`}
                        format="###"
                        onChange={(e) => {
                          field.onChange(e);
                        }} />
                    )}
                    control={control3}
                    name="long_lived_current_addrs"
                    ref={register3}
                    defaultValue={props?.applicantData?.long_lived_current_addrs}
                    rules={{
                      required: 'This field is required.',
                      maxLength: {
                        value: 3,
                        message: "Lived present address can not be more than 3 digits."
                      },
                    }}
                  />
                  {errors3.long_lived_current_addrs && (<p className={`${styles.ErrorM}`}>{errors3.long_lived_current_addrs.message}</p>)}
                </div>
              </div>
              <div className={`${styles.FormGroupHalf} ${styles.Dollar}`}>
                <label className={`${styles.FormLabel}`}>Current rent per month in USD</label>
                <div className={`${styles.Width100}`}>
                  <p className={`${styles.AccoDollarSign}`}><DollarSign /></p>
                  <Controller
                    render={(field) => (
                      <MoneyFieldCurrentRent
                        {...field}
                        type="text"
                        className={`${styles.formControl}`}
                        onChange={(e) => {
                          field.onChange(e);
                        }} />
                    )}
                    control={control3}
                    name="current_rent"
                    ref={register3}
                    defaultValue={props?.applicantData?.current_rent}
                    rules={{
                      required: 'This field is required.',
                      validate: (value, formValues) => parseInt(value.replace(/,/g, '')) < 10000 || 'Current rent can not be more than 4 digits.'
                    }}
                  />
                  {errors3.current_rent && (<p className={`${styles.ErrorM}`}>{errors3.current_rent.message}</p>)}
                </div>
              </div>
            </div>

            {(props?.applicantData?.landlord_name !== watch3('landlord_name') || props?.applicantData?.landlord_phone_no !== watch3('landlord_phone_no') || props?.applicantData?.reason_for_moving !== watch3('reason_for_moving') || props?.applicantData?.who_live_with_you !== watch3('who_live_with_you') || props?.applicantData?.long_lived_current_addrs !== watch3('long_lived_current_addrs') || props?.applicantData?.current_rent !== watch3('current_rent')) && <button type="submit" className={`${styles.ButtonVoiletSolidSM}`}>Update</button>}
          </form>
        </AccordionDetails>
      </Accordion>

      <Accordion expanded={expanded === "panel5"} onChange={handleChange("panel5")}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel5bh-content" id="panel5bh-header">
          <div className={`${styles.FormAccoHead}`}>
            <p className={`${styles.FormAccoHeadTitle}`}>Employment</p>
            <div className={(props?.applicantData?.is_employement_submitted === 1) ? `${styles.AccoCheck} ${styles.Active}` : `${styles.AccoCheck}`}>
              <Check />
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <form onSubmit={handleSubmit4(onSubmit4)}>
            <div className={`${styles.AccoFormSec}`}>
              <div className={`${styles.FormGroupHalf} CusSelect Select`}>
                <label className={`${styles.FormLabel}`}>Employment</label>
                <div className={`${styles.Width100}`}>
                  <FormControl fullWidth>
                    <Controller
                      name="employement"
                      control={control4}
                      rules={{
                        required: 'This field is required.',
                      }}
                      defaultValue={props?.applicantData?.employement}
                      render={(field) => (
                        <Select
                          {...field}
                        >
                          <MenuItem value={'Full-Time'}>{'Full-Time'}</MenuItem>
                          <MenuItem value={'Part-Time'}>{'Part-Time'}</MenuItem>
                        </Select>
                      )}
                    />
                    {errors4.employement && <p className={`${styles.ErrorM}`}>{errors4.employement.message}</p>}
                  </FormControl>
                </div>
              </div>
              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>Employer name</label>
                <div className={`${styles.Width100}`}>
                  <Controller
                    render={(fields) => (
                      <input
                        {...fields}
                        type="text"
                        className={`${styles.formControl}`}
                      />
                    )}
                    control={control4}
                    name="employer_name"
                    ref={register4}
                    defaultValue={props?.applicantData?.employer_name}
                    rules={{
                      required: "This field is required.",
                      maxLength: {
                        value: 50,
                        message: "Employer name can not be more than 50 characters."
                      }
                    }}
                  />
                  {errors4.employer_name && (<p className={`${styles.ErrorM}`}>{errors4.employer_name.message}</p>)}
                </div>
              </div>
              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>Employer address</label>
                <div className={`${styles.Width100}`}>
                  <Controller
                    render={(field) => (<TextField
                      {...field}
                      inputRef={autocompleteRef2}
                      autoComplete='off'
                      placeholder=""
                      className={`${styles.formControl}`}
                    />)}
                    control={control4}
                    name="employer_address"
                    ref={register4}
                    defaultValue={props?.applicantData?.employer_address}
                    rules={{
                      required: 'This field is required.',
                      maxLength: {
                        value: 50,
                        message: "Employer address can not be more than 50 characters."
                      }
                    }}
                  />
                  {errors4.employer_address && (<p className={`${styles.ErrorM}`}>{errors4.employer_address.message}</p>)}
                </div>
              </div>
              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>Years employed</label>
                <div className={`${styles.Width100}`}>
                  <Controller
                    render={(field) => (
                      <TenDigitField
                        {...field}
                        type="text"
                        className={`${styles.formControl}`}
                        format="##"
                      />
                    )}
                    control={control4}
                    name="years_employed"
                    ref={register4}
                    defaultValue={props?.applicantData?.years_employed}
                    rules={{
                      required: 'This field is required.',
                      masLength: {
                        value: 2,
                        message: "Years employeed can not be more than 2 digits."
                      },
                    }}
                  />
                  {errors4.years_employed && (<p className={`${styles.ErrorM}`}>{errors4.years_employed.message}</p>)}
                </div>
              </div>
              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>Job title</label>
                <div className={`${styles.Width100}`}>
                  <Controller
                    render={(fields) => (
                      <input
                        {...fields}
                        type="text"
                        className={`${styles.formControl}`}
                      />
                    )}
                    control={control4}
                    name="job_title"
                    ref={register4}
                    defaultValue={props?.applicantData?.job_title}
                    rules={{
                      required: "This field is required.",
                      maxLength: {
                        value: 50,
                        message: "Employer name can not be more than 50 characters."
                      }
                    }}
                  />
                  {errors4.job_title && (<p className={`${styles.ErrorM}`}>{errors4.job_title.message}</p>)}
                </div>
              </div>
              <div className={`${styles.FormGroupHalf} CusSelect Select`}>
                <label className={`${styles.FormLabel}`}>Income Type</label>
                <div className={`${styles.Width100}`}>
                  <FormControl fullWidth>
                    <Controller
                      name="income_type"
                      control={control4}
                      rules={{
                        required: 'This field is required.',
                      }}
                      defaultValue={props?.applicantData?.income_type}
                      render={(field) => (
                        <Select
                          {...field}
                          onChange={(e) => {
                            field.onChange(e);
                            setIncomeType(e.target.value)
                          }}
                        >
                          <MenuItem value={'Salary'}>{'Salary'}</MenuItem>
                          <MenuItem value={'Voucher'}>{'Voucher'}</MenuItem>
                        </Select>
                      )}
                    />
                    {errors4.income_type && <p className={`${styles.ErrorM}`}>{errors4.income_type.message}</p>}
                  </FormControl>
                </div>
              </div>
              {incomeType === "Voucher" ? <div className={`${styles.FormGroupHalf} ${styles.Dollar}`}>
                <label className={`${styles.FormLabel}`}>Amount</label>
                <div className={`${styles.Width100}`}>
                  <p className={`${styles.AccoDollarSign}`}><DollarSign /></p>
                  <Controller
                    render={(fields) => (
                      <MoneyField
                        {...fields}
                        type="text"
                        className={`${styles.formControl}`}
                      />
                    )}
                    control={control4}
                    name="voucher_amount"
                    ref={register4}
                    defaultValue={props?.applicantData?.voucher_amount}
                    rules={{
                      required: 'This field is required.'
                    }}
                  />
                  {errors4.voucher_amount && (<p className={`${styles.ErrorM}`}>{errors4.voucher_amount.message}</p>)}
                </div>
              </div> : <div className={`${styles.FormGroupHalf} ${styles.Dollar}`}>
                <label className={`${styles.FormLabel}`}>Income per year in USD</label>
                <div className={`${styles.Width100}`}>
                  <p className={`${styles.AccoDollarSign}`}><DollarSign /></p>
                  <Controller
                    render={(fields) => (
                      <MoneyField
                        {...fields}
                        type="text"
                        className={`${styles.formControl}`}
                      />
                    )}
                    control={control4}
                    name="income_per_year"
                    ref={register4}
                    defaultValue={props?.applicantData?.income_per_year}
                    rules={{
                      required: 'This field is required.',
                      maxLength: {
                        value: 7,
                        message: "Income per year can not be more than 6 digits."
                      },
                    }}
                  />
                  {errors4.income_per_year && (<p className={`${styles.ErrorM}`}>{errors4.income_per_year.message}</p>)}
                </div>
              </div>}

              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>Hire date</label>
                <div className={`${styles.Width100}`}>
                  <div className={`AppliAccoFormDate ${styles.AppliAccoFormDateTenantDE}`}>
                    <Controller
                      control={control4}
                      name="hire_date"
                      animateYearScrolling
                      render={(fields) => (
                        <DatePicker
                          {...fields}
                          placeholder="MM/DD/YYYY"
                          format="MM/dd/yyyy"
                          value={fields.value ? fields.value : null}
                          error={false}
                          animateYearScrolling
                        />
                      )}
                      rules={{ required: "This field is required." }}
                      defaultValue={props?.applicantData?.hire_date ? props?.applicantData?.hire_date : null}
                    />
                    <p className={`${styles.CalendarIcon}`}><Calendar /></p>
                  </div>
                  {errors4.hire_date && (<p className={`${styles.ErrorM}`}>{errors4.hire_date.message}</p>)}
                </div>
              </div>
            </div>

            {(props?.applicantData?.employement !== watch4('employement') || props?.applicantData?.employer_name !== watch4('employer_name') || props?.applicantData?.employer_address !== watch4('employer_address') || props?.applicantData?.years_employed !== watch4('years_employed') || props?.applicantData?.job_title !== watch4('job_title') || props?.applicantData?.income_type !== watch4('income_type') || (incomeType === "Voucher" && props?.applicantData?.voucher_amount !== watch4('voucher_amount')) || (incomeType === "Salary" && props?.applicantData?.income_per_year !== watch4('income_per_year')) || dayjs(props?.applicantData?.hire_date).format("MM/DD/YYYY") !== dayjs(watch4('hire_date')).format("MM/DD/YYYY")) && <button type="submit" className={`${styles.ButtonVoiletSolidSM}`}>Update</button>}

          </form>
        </AccordionDetails>
      </Accordion>

      {(props?.applicantData?.is_employement2 === 1) && (<Accordion expanded={expanded === "panel51"} onChange={handleChange("panel51")}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel5bh-content" id="panel5bh-header">
          <div className={`${styles.FormAccoHead}`}>
            <p className={`${styles.FormAccoHeadTitle}`}>2nd Employment</p>
            <div className={(props?.applicantData?.is_employement2_submitted === 1) ? `${styles.AccoCheck} ${styles.Active}` : `${styles.AccoCheck}`}>
              <Check />
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <form onSubmit={handleSubmit5(onSubmit5)}>
            <div className={`${styles.AccoFormSec}`}>
              <div className={`${styles.FormGroupHalf} CusSelect Select`}>
                <label className={`${styles.FormLabel}`}>Employment</label>
                <div className={`${styles.Width100}`}>
                  <FormControl fullWidth>
                    <Controller
                      name="employement2"
                      control={control5}
                      rules={{
                        required: 'This field is required.',
                      }}
                      defaultValue={props?.applicantData?.employement2}
                      render={(field) => (
                        <Select
                          {...field}
                        >
                          <MenuItem value={'Full-Time'}>{'Full-Time'}</MenuItem>
                          <MenuItem value={'Part-Time'}>{'Part-Time'}</MenuItem>
                        </Select>
                      )}
                    />
                    {errors5.employement2 && <p className={`${styles.ErrorM}`}>{errors5.employement2.message}</p>}
                  </FormControl>
                </div>
              </div>
              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>Employer name</label>
                <div className={`${styles.Width100}`}>
                  <Controller
                    render={(fields) => (
                      <input
                        {...fields}
                        type="text"
                        className={`${styles.formControl}`}
                      />
                    )}
                    control={control5}
                    name="employer_name2"
                    ref={register5}
                    defaultValue={props?.applicantData?.employer_name2}
                    rules={{
                      required: "This field is required.",
                      maxLength: {
                        value: 50,
                        message: "Employer name can not be more than 50 characters."
                      }
                    }}
                  />
                  {errors5.employer_name2 && (<p className={`${styles.ErrorM}`}>{errors5.employer_name2.message}</p>)}
                </div>
              </div>
              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>Employer address</label>
                <div className={`${styles.Width100}`}>
                  <Controller
                    render={(field) => (<TextField
                      {...field}
                      inputRef={autocompleteRef3}
                      autoComplete='off'
                      placeholder=""
                      className={`${styles.formControl}`}
                    />)}
                    control={control5}
                    name="employer_address2"
                    ref={register5}
                    defaultValue={props?.applicantData?.employer_address2}
                    rules={{
                      required: 'This field is required.',
                      maxLength: {
                        value: 50,
                        message: "Employer address can not be more than 50 characters."
                      }
                    }}
                  />
                  {errors5.employer_address2 && (<p className={`${styles.ErrorM}`}>{errors5.employer_address2.message}</p>)}
                </div>
              </div>
              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>Years employed</label>
                <div className={`${styles.Width100}`}>
                  <Controller
                    render={(field) => (
                      <TenDigitField
                        {...field}
                        type="text"
                        className={`${styles.formControl}`}
                        format="##"
                      />
                    )}
                    control={control5}
                    name="years_employed2"
                    ref={register5}
                    defaultValue={props?.applicantData?.years_employed2}
                    rules={{
                      required: 'This field is required.',
                      masLength: {
                        value: 2,
                        message: "Years employeed can not be more than 2 digits."
                      },
                    }}
                  />
                  {errors5.years_employed2 && (<p className={`${styles.ErrorM}`}>{errors5.years_employed2.message}</p>)}
                </div>
              </div>
              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>Job title</label>
                <div className={`${styles.Width100}`}>
                  <Controller
                    render={(fields) => (
                      <input
                        {...fields}
                        type="text"
                        className={`${styles.formControl}`}
                      />
                    )}
                    control={control5}
                    name="job_title2"
                    ref={register5}
                    defaultValue={props?.applicantData?.job_title2}
                    rules={{
                      required: "This field is required.",
                      maxLength: {
                        value: 50,
                        message: "Employer name can not be more than 50 characters."
                      }
                    }}
                  />
                  {errors5.job_title2 && (<p className={`${styles.ErrorM}`}>{errors5.job_title2.message}</p>)}
                </div>
              </div>
              <div className={`${styles.FormGroupHalf} CusSelect Select`}>
                <label className={`${styles.FormLabel}`}>Income Type</label>
                <div className={`${styles.Width100}`}>
                  <FormControl fullWidth>
                    <Controller
                      name="income_type2"
                      control={control5}
                      rules={{
                        required: 'This field is required.',
                      }}
                      defaultValue={props?.applicantData?.income_type2}
                      render={(field) => (
                        <Select
                          {...field}
                          onChange={(e) => {
                            field.onChange(e);
                            setIncomeType2(e.target.value)
                          }}
                        >
                          <MenuItem value={'Salary'}>{'Salary'}</MenuItem>
                          <MenuItem value={'Voucher'}>{'Voucher'}</MenuItem>
                        </Select>
                      )}
                    />
                    {errors5.income_type2 && <p className={`${styles.ErrorM}`}>{errors5.income_type2.message}</p>}
                  </FormControl>
                </div>
              </div>
              {incomeType2 === "Voucher" ? <div className={`${styles.FormGroupHalf} ${styles.Dollar}`}>
                <label className={`${styles.FormLabel}`}>Amount</label>
                <div className={`${styles.Width100}`}>
                  <p className={`${styles.AccoDollarSign}`}><DollarSign /></p>
                  <Controller
                    render={(fields) => (
                      <MoneyField
                        {...fields}
                        type="text"
                        className={`${styles.formControl}`}
                      />
                    )}
                    control={control5}
                    name="voucher_amount2"
                    ref={register5}
                    defaultValue={props?.applicantData?.voucher_amount2}
                    rules={{
                      required: 'This field is required.'
                    }}
                  />
                  {errors5.voucher_amount2 && (<p className={`${styles.ErrorM}`}>{errors5.voucher_amount2.message}</p>)}
                </div>
              </div> : <div className={`${styles.FormGroupHalf} ${styles.Dollar}`}>
                <label className={`${styles.FormLabel}`}>Income per year in USD</label>
                <div className={`${styles.Width100}`}>
                  <p className={`${styles.AccoDollarSign}`}><DollarSign /></p>
                  <Controller
                    render={(fields) => (
                      <MoneyField
                        {...fields}
                        type="text"
                        className={`${styles.formControl}`}
                      />
                    )}
                    control={control5}
                    name="income_per_year2"
                    ref={register5}
                    defaultValue={props?.applicantData?.income_per_year2}
                    rules={{
                      required: 'This field is required.',
                      maxLength: {
                        value: 7,
                        message: "Income per year can not be more than 6 digits."
                      },
                    }}
                  />
                  {errors5.income_per_year2 && (<p className={`${styles.ErrorM}`}>{errors5.income_per_year2.message}</p>)}
                </div>
              </div>}

              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>Hire date</label>
                <div className={`${styles.Width100}`}>
                  <div className={`AppliAccoFormDate ${styles.AppliAccoFormDateTenantDE}`}>
                    <Controller
                      control={control5}
                      name="hire_date2"
                      animateYearScrolling
                      render={(fields) => (
                        <DatePicker
                          {...fields}
                          placeholder="MM/DD/YYYY"
                          format="MM/dd/yyyy"
                          value={fields.value ? fields.value : null}
                          error={false}
                          animateYearScrolling
                        />
                      )}
                      rules={{ required: "This field is required." }}
                      defaultValue={props?.applicantData?.hire_date2 ? props?.applicantData?.hire_date2 : null}
                    />
                    <p className={`${styles.CalendarIcon}`}><Calendar /></p>
                  </div>
                  {errors5.hire_date2 && (<p className={`${styles.ErrorM}`}>{errors5.hire_date2.message}</p>)}
                </div>
              </div>
            </div>

            {(props?.applicantData?.employement2 !== watch5('employement2') || props?.applicantData?.employer_name2 !== watch5('employer_name2') || props?.applicantData?.employer_address2 !== watch5('employer_address2') || props?.applicantData?.years_employed2 !== watch5('years_employed2') || props?.applicantData?.job_title2 !== watch5('job_title2') || props?.applicantData?.income_type2 !== watch5('income_type2') || (incomeType2 === "Voucher" && props?.applicantData?.voucher_amount2 !== watch5('voucher_amount2')) || (incomeType2 === "Salary" && props?.applicantData?.income_per_year2 !== watch5('income_per_year2')) || dayjs(props?.applicantData?.hire_date2).format("MM/DD/YYYY") !== dayjs(watch5('hire_date2')).format("MM/DD/YYYY")) && <button type="submit" className={`${styles.ButtonVoiletSolidSM}`}>Update</button>}

          </form>
        </AccordionDetails>
      </Accordion>)}

      <Accordion expanded={expanded === "panel6"} onChange={handleChange("panel6")}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel5bh-content" id="panel5bh-header">
          <div className={`${styles.FormAccoHead}`}>
            <p className={`${styles.FormAccoHeadTitle}`}>Other information</p>
            <div className={(props?.applicantData?.is_other_info_submitted === 1) ? `${styles.AccoCheck} ${styles.Active}` : `${styles.AccoCheck}`}>
              <Check />
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <form onSubmit={handleSubmit6(onSubmit6)}>
            <div className={`${styles.AccoFormSec}`}>
              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>How many evictions have been filed upon you?</label>
                <div className={`${styles.Width100}`}>
                  <Controller
                    name="ever_evicted"
                    control={control6}
                    rules={{
                      required: 'This field is required.',
                      maxLength: {
                        value: 2,
                        message: "Evicted can not be more than 2 digits."
                      },
                    }}
                    defaultValue={props?.applicantData?.ever_evicted}
                    render={(field) => (
                      <TenDigitField
                        {...field}
                        format="##"
                        className={`${styles.formControl}`}
                      />
                    )}
                  />
                  {errors6.ever_evicted && <p className={`${styles.ErrorM}`}>{errors6.ever_evicted.message}</p>}
                </div>
              </div>
              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>How many cases have been filled with you in housing court?</label>
                <div className={`${styles.Width100}`}>
                  <Controller
                    name="ever_case_filed"
                    control={control6}
                    rules={{
                      required: 'This field is required.',
                      maxLength: {
                        value: 2,
                        message: "Case filed can not be more than 2 digits."
                      },
                    }}
                    defaultValue={props?.applicantData?.ever_case_filed}
                    render={(field) => (
                      <TenDigitField
                        {...field}
                        format="##"
                        className={`${styles.formControl}`}
                      />
                    )}
                  />
                  {errors6.ever_case_filed && <p className={`${styles.ErrorM}`}>{errors6.ever_case_filed.message}</p>}
                </div>
              </div>
              <div className={`${styles.ToggleBUHalf} CusSelect Select`}>
                <div className={`${styles.Width100}`}>
                  <label className={`${styles.FormLabel}`}>Have you ever broken a lease?</label>
                  <FormControl fullWidth>
                    <Controller
                      name="ever_broken_lease"
                      control={control6}
                      rules={{
                        required: 'This field is required.',
                      }}
                      defaultValue={props?.applicantData?.ever_broken_lease}
                      render={(field) => (
                        <Select
                          {...field}
                        >
                          <MenuItem value={'Yes'}>{'Yes'}</MenuItem>
                          <MenuItem value={'No'}>{'No'}</MenuItem>
                        </Select>
                      )}
                    />
                    {errors6.ever_broken_lease && <p className={`${styles.ErrorM}`}>{errors6.ever_broken_lease.message}</p>}
                  </FormControl>
                </div>
              </div>
              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>What is your credit score?</label>
                <div className={`${styles.Width100}`}>
                  <Controller
                    name="credit_score"
                    control={control6}
                    rules={{
                      required: 'This field is required.',
                      pattern: {
                        value: /\b\d{3}\b/,
                        message: "Please enter valid credit score."
                      },
                    }}
                    defaultValue={props?.applicantData?.credit_score}
                    render={(field) => (
                      <TenDigitField
                        {...field}
                        format="###"
                        label="Credit Score"
                        className={`${styles.formControl}`} />
                    )}
                  />
                  {errors6.credit_score && <p className={`${styles.ErrorM}`}>{errors6.credit_score.message}</p>}
                </div>
              </div>
              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>How many pets do you have?</label>
                <div className={`${styles.Width100}`}>
                  <Controller
                    name="have_pets"
                    control={control6}
                    rules={{
                      required: 'This field is required.',
                      maxLentgh: {
                        value: 1,
                        message: "Pets field  can not be more than 1 digit."
                      },
                    }}
                    defaultValue={props?.applicantData?.have_pets}
                    render={(field) => (
                      <TenDigitField
                        {...field}
                        format="##"
                        className={`${styles.formControl}`}
                      />
                    )}
                  />
                  {errors6.have_pets && <p className={`${styles.ErrorM}`}>{errors6.have_pets.message}</p>}
                </div>
              </div>
              <div className={`${styles.ToggleBUHalf} CusSelect Select`}>
                <div className={`${styles.Width100}`}>
                  <label className={`${styles.FormLabel}`}>Have you ever had bed bugs?</label>
                  <FormControl fullWidth>
                    <Controller
                      name="ever_had_bedbugs"
                      control={control6}
                      rules={{
                        required: 'This field is required.',
                      }}
                      defaultValue={props?.applicantData?.ever_had_bedbugs}
                      render={(field) => (
                        <Select
                          {...field}
                        >
                          <MenuItem value={'Yes'}>{'Yes'}</MenuItem>
                          <MenuItem value={'No'}>{'No'}</MenuItem>
                        </Select>
                      )}
                    />
                    {errors6.ever_had_bedbugs && <p className={`${styles.ErrorM}`}>{errors6.ever_had_bedbugs.message}</p>}
                  </FormControl>
                </div>
              </div>
              <div className={`${styles.ToggleBUHalf} CusSelect Select`}>
                <div className={`${styles.Width100}`}>
                  <label className={`${styles.FormLabel}`}>Have you ever filed for bankruptcy?</label>
                  <FormControl fullWidth>
                    <Controller
                      name="ever_had_bankruptcy"
                      control={control6}
                      rules={{
                        required: 'This field is required.',
                      }}
                      defaultValue={props?.applicantData?.ever_had_bankruptcy}
                      render={(field) => (
                        <Select
                          {...field}
                        >
                          <MenuItem value={'Yes'}>{'Yes'}</MenuItem>
                          <MenuItem value={'No'}>{'No'}</MenuItem>
                        </Select>
                      )}
                    />
                    {errors6.ever_had_bankruptcy && <p className={`${styles.ErrorM}`}>{errors6.ever_had_bankruptcy.message}</p>}
                  </FormControl>
                </div>
              </div>
              <div className={`${styles.ToggleBUHalf} CusSelect Select`}>
                <div className={`${styles.Width100}`}>
                  <label className={`${styles.FormLabel}`}>Do you smoke?</label>
                  <FormControl fullWidth>
                    <Controller
                      name="do_you_smoke"
                      control={control6}
                      rules={{
                        required: 'This field is required.',
                      }}
                      defaultValue={props?.applicantData?.do_you_smoke}
                      render={(field) => (
                        <Select
                          {...field}
                        >
                          <MenuItem value={'Yes'}>{'Yes'}</MenuItem>
                          <MenuItem value={'No'}>{'No'}</MenuItem>
                        </Select>
                      )}
                    />
                    {errors6.do_you_smoke && <p className={`${styles.ErrorM}`}>{errors6.do_you_smoke.message}</p>}
                  </FormControl>
                </div>
              </div>
              <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`}>How many vehicles do you own?</label>
                <div className={`${styles.Width100}`}>
                  <Controller
                    name="own_vehicles"
                    control={control6}
                    rules={{
                      required: 'This field is required.',
                      maxLength: {
                        value: 1,
                        message: "Vehicles filed can not be more than 1 digit."
                      },
                    }}
                    defaultValue={props?.applicantData?.own_vehicles}
                    render={(field) => (
                      <TenDigitField
                        {...field}
                        format="#"
                        className={`${styles.formControl}`}
                      />
                    )}
                  />
                  {errors6.own_vehicles && <p className={`${styles.ErrorM}`}>{errors6.own_vehicles.message}</p>}
                </div>
              </div>
              <div className={`${styles.FormGroupFull} CusTextArea`}>
                <label className={`${styles.FormLabel}`}>Additional information <span>OPTIONAL</span></label>
                <p className={`${styles.FormLabelSmall}`}>Please use this space for additional information, comments or explanations.</p>
                <div className={`${styles.Width100}`}>
                  <Controller
                    render={(field) => (
                      <TextField
                        {...field}
                        multiline
                        className={`${styles.formControlTextarea}`}
                        rows={6}
                        onChange={(e) => {
                          field.onChange(e);
                          setCharsLeft((prev) => {
                            return { ...prev, additional_information: 200 - e.target.value.length };
                          });
                        }}
                        inputProps={{ maxLength: 200 }}
                      />
                    )}
                    control={control6}
                    name="additional_information"
                    ref={register6}
                    defaultValue={props?.applicantData?.additional_information}
                  />
                  <p className={`${styles.FormFieldMessage}`}>{charsLeft?.additional_information > 1 ? charsLeft?.additional_information + " characters remaining" : charsLeft?.additional_information + " character remaining"}</p>
                  {errors6.additional_information && (<p className={`${styles.ErrorM}`}>{errors6.additional_information.message}</p>)}
                </div>
              </div>
            </div>

            {(props?.applicantData?.ever_evicted !== watch6('ever_evicted') || props?.applicantData?.ever_case_filed !== watch6('ever_case_filed') || props?.applicantData?.ever_broken_lease !== watch6('ever_broken_lease') || props?.applicantData?.credit_score !== watch6('credit_score') || props?.applicantData?.have_pets !== watch6('have_pets') || props?.applicantData?.ever_had_bedbugs !== watch6('ever_had_bedbugs') || props?.applicantData?.ever_had_bankruptcy !== watch6('ever_had_bankruptcy') || props?.applicantData?.do_you_smoke !== watch6('do_you_smoke') || props?.applicantData?.own_vehicles !== watch6('own_vehicles') || props?.applicantData?.additional_information !== watch6('additional_information')) && <button type="submit" className={`${styles.ButtonVoiletSolidSM}`}>Update</button>}

          </form>
        </AccordionDetails>
      </Accordion>

      <Accordion expanded={expanded === "panel7"} onChange={handleChange("panel7")}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel5bh-content" id="panel5bh-header">
          <div className={`${styles.FormAccoHead}`}>
            <p className={`${styles.FormAccoHeadTitle}`}>Upload files</p>
            <div className={(props?.applicantData?.is_upload_files === 1) ? `${styles.AccoCheck} ${styles.Active}` : `${styles.AccoCheck}`}>
              <Check />
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <div className={`${styles.AccoFormSec}`}>
            <div className={`${styles.DivFull}`}>
              <p className={`${styles.FileUpTitle}`}>Please upload all the following supporting documents:</p>
              <ul className={`${styles.FileUpList}`}>
                <li>2024 W2 or 2024 Tax Return</li>
                <li>Last 4 Paystubs or Housing Voucher Award Letter</li>
                <li>Most Recent Bank Statement</li>
              </ul>
            </div>
            <div className={`${styles.FileIMGDiv}`}>
              {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("prospect:update") > -1 && (<UploaderComponent
                allowedExtensions={".pdf,.png,.jpg,.jpeg"}
                isMuliple={false}
                setLoading={setLoading.bind(this)}
                uploadUrl={process.env.REACT_APP_APPLICANT_API_URL + "v1/applicants/" + props?.applicantData?.id + "/files/upload"}
                onUploadLocal={onFileUploadSuccess.bind(this)}
              />)}
              <div className={`${styles.FileListRow}`}>
                {props?.applicantData?.files.map((itemFile, indexF) => {
                  return isRename?.itemId === itemFile.id ? (<div className={`${styles.UpFileList}`} key={indexF}>
                    <div className={`${styles.UpFileListUnder} ${styles.Active}`}>
                      <div className={`${styles.FileName}`}>
                        <FileText />{" "}
                        <TextField hiddenLabel autoFocus error={isRename?.error} variant="outlined" className={`${styles.FileRenameField}`} defaultValue={isRename.value} onChange={(e) => setIsRename({ ...isRename, value: e.target.value })} />
                      </div>
                      <p className={`${styles.FileSize}`}>{dayjs(itemFile?.created_at).format("MM/DD/YYYY LT")}</p>
                      {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("prospect:update") > -1 && <div className={`${styles.FileListRight}`}>
                        <Button className={`${styles.FileListRename}`} onClick={fileRenameSave.bind(this)}><Save /></Button>
                        <Button className={`${styles.FileListCancel}`} onClick={(e) => setIsRename({ itemId: 0, error: false, value: "" })}><X /></Button>
                      </div>}
                    </div>
                  </div>) : (<div className={`${styles.UpFileList}`} key={indexF} onClick={(e) => openFile(itemFile)}>
                    <div className={`${styles.UpFileListUnder}`}>
                      <p className={`${styles.FileName}`}>
                        {itemFile.file_type === "pdf" ? (<FileText />) : (<Image />)}{" "}
                        <span>{itemFile.file_name}</span>
                      </p>
                      <p className={`${styles.FileSize}`}>{dayjs(itemFile?.created_at).format("MM/DD/YYYY LT")}</p>
                      <div className={`${styles.FileListRight}`}>
                        <Button className={`${styles.FileListRename}`} onClick={fileRenameFormOpen.bind(this, itemFile.id, itemFile.file_name)}><Edit /></Button>
                        <Button className={`${styles.FileListDelete}`} onClick={(e) => { e.stopPropagation(); setIsModalOpen(true); setFileDeleteId(itemFile?.id); }}><Trash2 /></Button>
                      </div>
                    </div>
                  </div>);
                })}
              </div>
              <Dialog open={isModalOpen} fullWidth maxWidth="sm" onClose={(e) => { setIsModalOpen(false); setFileDeleteId(0); }} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" className="NewPopUp">
                <DialogTitle id="alert-dialog-title">
                  Delete Document
                  <button onClick={(e) => { setIsModalOpen(false); setFileDeleteId(0); }}><X /></button>
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description" className="ModalFormGroup" style={{ marginBottom: "0px", padding: "25px 0" }}>
                    <label className="PopupBodyText">Are you sure you want to delete the uploaded document? The uploaded document will be removed immediately. You
                      can't undo this action.</label>
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button className="CancelPopupBU" onClick={deleteFile.bind(this)}>Delete</Button>
                  <Button onClick={(e) => { setIsModalOpen(false); setFileDeleteId(0); }} className="SubmitPopupBU">Cancel</Button>
                </DialogActions>
              </Dialog>
            </div>
          </div>
        </AccordionDetails>
      </Accordion>

      <Accordion expanded={expanded === "panel8"} onChange={handleChange("panel8")}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel5bh-content" id="panel5bh-header">
          <div className={`${styles.FormAccoHead}`}>
            <p className={`${styles.FormAccoHeadTitle}`}>Signature</p>
            <div className={(props?.applicantData?.is_term_submitted === 1) ? `${styles.AccoCheck} ${styles.Active}` : `${styles.AccoCheck}`}>
              <Check />
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <div className={`${styles.AccoFormSec}`}>
            <div className={`${styles.SignarureBody}`}>
              {props?.applicantData?.signature && props?.applicantData?.signature !== "" && (<div className={`${styles.UploadImgSign}`}>
                <img src={props?.applicantData?.signature} alt="applicantImage" />
              </div>)}
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  </>);
};

export default ProspectTab;